module.exports = __webpack_public_path__ + "img/engine.f5da07f3.png";